import AnalyticsTimeCard from './AnalyticsTimeCard';

export default AnalyticsTimeCard;
